import {
	Navigate, Route, Routes, Outlet, useLocation,
} from 'react-router';
import SpotifySuperGrid from 'wb-spotify/app/routes/superGrid/container';
import { LayoutRefContext } from 'wb-reddit/app/routes/context/layoutContext';
import { SpotifyReports } from 'wb-spotify/app/routes/reports/index';
import useUserMetaData from 'wb-reddit/app/common/hooks/useUserMetaData';
import RedditUsersContainer from 'wb-reddit/app/routes/users/container';
import RedditTeamsContainer from 'wb-reddit/app/routes/teams/container';
import RedditAdvertisersContainer from 'wb-reddit/app/routes/advertisers/container';
import NotFound from 'wb-reddit/app/routes/notFound';
import AcceptInvite from 'wb-reddit/app/common/components/acceptInvite';
import classNames from 'classnames';
import { useRef } from 'react';
import { AppEnum } from '@aleph/shared-components';
import { SPOTIFY_ADVERTISERS_ROUTE_ALLOWED_ROLES } from 'wb-spotify/app/common/utils';

export const LAYOUT_ID = 'layout';

const AppRoutes = () => {
	const userMetaData = useUserMetaData(AppEnum.SPOTIFY);

	if (!userMetaData) {
		return null;
	}

	const Layout = () => {
		const location = useLocation();
		const currentPath = location.pathname?.split('/')?.[1] ?? '';
		const layoutRef = useRef<HTMLDivElement>(null); // Create a ref with HTMLDivElement type

		if (!SPOTIFY_ADVERTISERS_ROUTE_ALLOWED_ROLES.includes(userMetaData?.userAccountLevel) && currentPath === 'advertisers') {
			return <Navigate to="/" />;
		}

		return (
			<LayoutRefContext.Provider value={layoutRef}>
				<div
					id={LAYOUT_ID}
					ref={layoutRef} // Assign the ref to the div
					className={classNames('flex w-full h-full px-[40px]', {
						'overflow-auto flex-col': ['users', 'teams', 'advertisers', 'reports'].includes(currentPath),
					})}
				>
					<Outlet />
				</div>
			</LayoutRefContext.Provider>
		);
	};

	return (
		<Routes>
			<Route path="/"
				element={<Layout />}
			>
				<Route
					path="*"
					element={<NotFound />}
				/>
				<Route
					index
					element={
						<Navigate
							to="/superGrid"
							replace
						/>
					}
				/>
				<Route
					path="/superGrid"
					element={<SpotifySuperGrid />}
				/>
				<Route
					path="/superGrid/:params"
					element={<SpotifySuperGrid />}
				/>
				<Route
					path="/OAuth"
					element={<SpotifySuperGrid />}
				/>
				<Route
					path="/OAuth/:params"
					element={<SpotifySuperGrid />}
				/>
				<Route
					path="/reports"
					element={<SpotifyReports />}
				/>
				<Route
					path="/reports/:params"
					element={<SpotifyReports />}
				/>
				<Route
					path="/account"
					element={<SpotifyReports />}
				/>
				<Route
					path="/account/:params"
					element={<SpotifyReports />}
				/>
				<Route
					path="/advertisers"
					element={<RedditAdvertisersContainer />}
				/>
				<Route
					path="/advertisers/:params"
					element={<RedditAdvertisersContainer />}
				/>
				<Route
					path="/teams"
					element={<RedditTeamsContainer />}
				/>
				<Route
					path="/teams/:params"
					element={<RedditTeamsContainer />}
				/>
				<Route
					path="/users"
					element={<RedditUsersContainer />}
				/>
				<Route
					path="/acceptUserInvite"
					element={<AcceptInvite />}
				/>
			</Route>
		</Routes>
	);
};

export default AppRoutes;
